export const DONUT_SIZE = 170;
export const DONUT_THICKNESS = 11.73;
export const DONUT_RADIUS = DONUT_SIZE / 2 - DONUT_THICKNESS / 2;
export const DONUT_CIRCUMFERENCE = 2 * Math.PI * DONUT_RADIUS;
